import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-unassigned-owner",
  "use": "icon-unassigned-owner-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-unassigned-owner\">\n<circle cx=\"12\" cy=\"12\" r=\"11\" stroke=\"#B5BBC5\" stroke-width=\"2\" />\n<path d=\"M20.5 4L4 20.5\" stroke=\"#B5BBC5\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol